import { render } from "./StatisticsPublic.vue?vue&type=template&id=2acf5878&scoped=true&ts=true"
import script from "./StatisticsPublic.vue?vue&type=script&lang=ts"
export * from "./StatisticsPublic.vue?vue&type=script&lang=ts"

import "./StatisticsPublic.vue?vue&type=style&index=0&id=2acf5878&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acf5878"]])

export default __exports__